'use client';

import { SectionHeader } from '../shared';
import { cn } from '@/lib/utils/cn';

interface VendorResponse {
  cdk?: string;
  vendor?: { name?: string; semantic_id?: string } | null;
  status?: string;
  total_quoted?: number | null;
  response_date?: string | null;
}

interface ResponsesSectionProps {
  responses: VendorResponse[] | null | undefined;
  label?: string | null;
}

const STATUS_COLORS: Record<string, string> = {
  submitted: 'border-l-success',
  draft: 'border-l-muted-foreground',
  revised: 'border-l-info',
};

export function ResponsesSection({ responses, label }: ResponsesSectionProps) {
  if (!responses || responses.length === 0) {
    return null;
  }

  // Show only latest response per vendor (skip revised/superseded)
  const latestByVendor = new Map<string, VendorResponse>();
  for (const r of responses) {
    const key = r.vendor?.semantic_id || r.vendor?.name || r.cdk || '';
    const existing = latestByVendor.get(key);
    if (!existing || r.status !== 'revised') {
      latestByVendor.set(key, r);
    }
  }
  const current = [...latestByVendor.values()];

  return (
    <div>
      <SectionHeader title={label || 'VENDOR RESPONSES'} count={current.length} />
      <div className="space-y-1.5">
        {current.map((response, index) => (
          <div
            key={response.cdk ?? index}
            className={cn(
              'p-2 rounded-lg bg-card border border-border border-l-4',
              STATUS_COLORS[response.status || ''] || 'border-l-muted-foreground'
            )}
          >
            <div className="flex justify-between items-center">
              <span className="text-xs font-medium truncate">
                {response.vendor?.name || 'Unknown Vendor'}
              </span>
              {response.total_quoted != null && (
                <span className="text-xs font-semibold text-success">
                  ${response.total_quoted.toFixed(0)}
                </span>
              )}
            </div>
            {response.status && (
              <span className="text-[10px] text-muted-foreground capitalize">
                {response.status}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
